module.exports = __webpack_public_path__ + "img/Small-2-Bevel-Attachment-47.a330694b.png";